import { jsx as _jsx } from "react/jsx-runtime";
var FirstPage = function FirstPage(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      d: "M5 5a1 1 0 0 0-2 0v14a1 1 0 1 0 2 0V5Zm4.135 6H20a1 1 0 0 1 0 2H9.135l3.633 4.36a1 1 0 1 1-1.536 1.28l-5-6c-.027-.032-.045-.068-.063-.104a1.092 1.092 0 0 0-.05-.091c-.017-.026-.034-.053-.046-.083a.985.985 0 0 1-.072-.358L6 12l.001-.004c0-.122.027-.243.072-.358a.467.467 0 0 1 .046-.083.901.901 0 0 0 .025-.041c.01-.016.017-.033.025-.05a.515.515 0 0 1 .063-.104l5-6a1 1 0 1 1 1.536 1.28L9.135 11Z",
      fill: color
    })
  });
};
export default FirstPage;